import { RefObject, useLayoutEffect, useState } from 'react';

const MAX_LINES = 5;
const DEFAULT_LINE_HEIGHT_RATIO = 1.4285714286;

export function useExpandableDescription(
  rootRef: RefObject<HTMLElement>,
  isExpanded: boolean,
) {
  const [hasOverflow, setHasOverflow] = useState(false);

  useLayoutEffect(() => {
    const root = rootRef.current;
    if (!root) return;

    const content = root.querySelector<HTMLElement>(
      '.k-tabstrip-top > .k-content, .k-tabstrip-top > .k-tabstrip-content',
    );

    if (!content) return;

    const updateHeight = () => {
      const contentStyles = globalThis.getComputedStyle(content);

      const textElement =
        content.querySelector<HTMLElement>('p, li, span, div');
      const textStyles = textElement
        ? globalThis.getComputedStyle(textElement)
        : contentStyles;

      const fontSize = Number.parseFloat(textStyles.fontSize);
      const lineHeight =
        textStyles.lineHeight === 'normal'
          ? fontSize * DEFAULT_LINE_HEIGHT_RATIO
          : Number.parseFloat(textStyles.lineHeight);

      const collapsedHeight =
        Number.parseFloat(contentStyles.paddingTop) +
        Number.parseFloat(contentStyles.paddingBottom) +
        lineHeight * MAX_LINES;

      const fullHeight = content.scrollHeight;
      const nextHasOverflow = fullHeight > collapsedHeight + 1;

      setHasOverflow(nextHasOverflow);

      root.style.setProperty(
        '--product-description-height',
        `${isExpanded ? fullHeight : collapsedHeight}px`,
      );
    };

    updateHeight();

    globalThis.addEventListener('resize', updateHeight);

    return () => {
      globalThis.removeEventListener('resize', updateHeight);
    };
  }, [rootRef, isExpanded]);

  return hasOverflow;
}
